export const allowList = ['login', 'register', 'register-result', 'recover', 'verify', 'sso'] // no redirect whitelist
export const loginRoutePath = '/user/login'
export const defaultRoutePath = '/dashboard'
